function setHeaderColor(color) {
  var style = document.createElement('style');
  style.innerHTML = `.esri-popup__header
  { 
    background: ${color};
  }`;
  document.body.appendChild(style);
}
export default setHeaderColor;
